import { useState } from 'react';

import ConsultaRemuneracaoVendedores from '../../components/ConsultaRemuneracaoVendedores/ConsultaRemuneracaoVendedores';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function RemuneracaoVendedores() {
    const [notify, setNotify] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });

    return (
        <>
            {notify.isActive && <NotifierPopup notify={notify} setNotify={setNotify} />}
            <ConsultaRemuneracaoVendedores
                setNotifier={(isSuccessful, message) => setNotify({
                    isActive: true,
                    isSuccessful,
                    message
                })}
            />
        </>
    );
}
